import { ResourcePathEnum } from '@easyguide/types'

import { ListView } from './List'

export const statistics = {
  name: ResourcePathEnum.statistics,
  list: ListView,
}
